import React, { Suspense } from 'react';
import { useNavigateWithHistory } from './useNavigateWithHistory';
import { NotFoundRoute } from './NotFoundRoute';
import { useFetchItem } from '../../service/areena-api/hooks/useFetchItem';
import getRoutePath from './getRoutePath';
import { LoadingOverlay } from '../common/loading/LoadingOverlay';
import { useGetItemIdFromRouter } from './useGetItemIdFromRoute';

export const ItemRoute: React.FC = () => <RouteBase isItemInfo={false} />;

export const ItemInfoRoute: React.FC = () => <RouteBase isItemInfo={true} />;

const ItemComponent = React.lazy(() => import('../Item/ItemViewContainer'));
const AuthRequired = React.lazy(() => import('./redirects/AuthRedirect'));

const RouteBase: React.FC<Props> = ({ isItemInfo }) => {
  const navigate = useNavigateWithHistory();

  const itemId = useGetItemIdFromRouter();
  const { data: itemView, isLoading } = useFetchItem(itemId);

  if (!itemId) {
    return <NotFoundRoute />; // 404
  }

  if (itemView?.meta?.redirectTo) {
    navigate(getRoutePath({ pointer: itemView.meta.redirectTo }));
  }

  return (
    <Suspense fallback={<LoadingOverlay isVisible={isLoading} />}>
      <AuthRequired>
        {itemView?.data && (
          <ItemComponent isSimplified={isItemInfo} itemView={itemView?.data} />
        )}
      </AuthRequired>
    </Suspense>
  );
};

type Props = {
  isItemInfo: boolean;
};
